export class Common {
    constructor () {}

    init() {
        let _this = this;
        _this.bindEvents();
    }

    bindEvents() {
        let _this = this;

        /**
         * Bootstrap tab change: Detect hash change event and activate tab accordingly
         */
        $(window).on( 'hashchange', function( e ) {
            let currentHash = window.location.hash;
            let currentHashVal = currentHash.replace('#', '');
            let $tabToClick = $('.nav-tabs a[href="'+currentHash+'"]');
            $tabToClick.click();

            /** make header menu link active */
            _this.handleHeaderHoverMenuLinkActive();
        });

        $('.settings_tabs a').on('shown.bs.tab', function (e) {
            /** make header menu link active */
            setTimeout(function() {
                _this.handleHeaderHoverMenuLinkActive();
            }, 1000);
        });
    }



    handleHeaderHoverMenuLinkActive = function () {
        let currentHash = window.location.hash;
        let currentHashVal = currentHash.replace('#', '');

        if ($('.header_hover_menu_'+currentHashVal).length) {
            $('.header_hover_menu .item').removeClass('active');
            $('.header_hover_menu_'+currentHashVal).addClass('active');
        }
    };
}